import React, { useEffect, useRef, useState } from "react"
import * as Yup from "yup"
import {
  Col,
  Container,
  Row,
  CardTitle,
  Label,
  Input,
  Button,
  Form,
} from "reactstrap"

import ArrowDown from "../../../assets/images/icons/ArrowDown.svg"
import editIcon from "../../../assets/images/icons/edit.svg"
import { addSpaceEveryNChars, checkExtension } from "helpers/common"
import { Link, useNavigate } from "react-router-dom"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import imageIcon from "../../../assets/images/icons/image.svg"
import { useDispatch, useSelector } from "react-redux"
import { setLoginUserData } from "store/slices/userSlice"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
// import Select from "react-select"
import Select, { components } from "react-select"

import { depositories } from "helpers/depositories"
import { reactSelectStyles } from "helpers/utils"
import { useKycFinalSubmissionProfileMutation } from "store/api/profile/profile.api"

const CustomDropdownIndicator = (props) => {
  const { isDisabled } = props.selectProps

  return (
    <components.DropdownIndicator {...props}>
      {!isDisabled ? <img className="cp" src={ArrowDown} alt="" /> : <></>}
    </components.DropdownIndicator>
  )
}

const KycFinalStep = ({ profileData }) => {
  const { userType, user } = useSelector((state) => state.user)
  const [kycFinalSubmission, { isLoading }] =
    useKycFinalSubmissionProfileMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const accountHolderRef = useRef()
  const accountNoRef = useRef()
  const bankNameRef = useRef()

  const submitForVerification = async () => {
    try {
      const { message, success } = await kycFinalSubmission().unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })

        navigate("/dashboard")
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <React.Fragment>
      <div
        style={{
          marginTop: "6rem",
          paddingInline: "2rem",
        }}
      >
        <Row>
          <Col xl={12}>
            <div>
              <div>
                <Row className="mb-2">
                  {profileData?.aadhaarDetails && (
                    <>
                      <div className="d-flex align-items-center mt-4 mb-4 justify-content-between">
                        <CardTitle className="">Personal Details</CardTitle>
                      </div>
                      <Col xl={6}>
                        <Label className="col-form-label">Name</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={profileData?.aadhaarDetails?.name}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Date of Birth</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={profileData?.aadhaarDetails?.dob}
                        />
                      </Col>
                    </>
                  )}
                  {profileData?.additionalDetails && (
                    <>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Primary Address
                        </Label>
                        <Input
                          disabled
                          name="email"
                          type="textarea"
                          className="form-control"
                          value={
                            profileData?.additionalDetails?.primary_address
                          }
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Secondary Address
                        </Label>
                        <Input
                          disabled
                          name="email"
                          type="textarea"
                          className="form-control"
                          value={
                            profileData?.additionalDetails?.secondary_address
                          }
                        />
                      </Col>
                      {/* {profileData?.additionalDetails?.business_trade_name && ( */}
                      <>
                        <Col xl={6}>
                          <Label className="col-form-label">
                            Trade Name of the Business
                          </Label>

                          <Input
                            disabled
                            name="phone"
                            type="text"
                            className="form-control"
                            value={
                              profileData?.additionalDetails
                                ?.business_trade_name || "Not Applicable"
                            }
                          />
                        </Col>
                        <Col xl={6}>
                          <Label className="col-form-label">GSTIN</Label>

                          <Input
                            disabled
                            name="phone"
                            type="text"
                            className="form-control"
                            value={
                              profileData?.additionalDetails?.gstin ||
                              "Not Applicable"
                            }
                          />
                        </Col>
                      </>
                      {/* )} */}
                    </>
                  )}

                  {profileData?.aadhaarDetails && (
                    <Col xl={6}>
                      <Label className="col-form-label">PAN</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={profileData?.panDetails?.pan}
                      />
                    </Col>
                  )}
                  {profileData?.aadhaarDetails && (
                    <Col xl={6}>
                      <Label className="col-form-label">Aadhaar No.</Label>
                      <Input
                        disabled
                        name="name"
                        type="text"
                        className="form-control"
                        value={addSpaceEveryNChars(
                          profileData?.aadhaarDetails?.aadhaar_no
                        )}
                      />
                    </Col>
                  )}
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {profileData?.bankDetails && (
          <Row>
            <Col xl={12}>
              <div>
                <div>
                  <div className="d-flex align-items-center mb-4 mt-4 justify-content-between">
                    <CardTitle className="">Bank Details</CardTitle>
                  </div>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Account Holders Name
                      </Label>
                      <Input
                        disabled
                        innerRef={accountHolderRef}
                        name="account_holder"
                        type="text"
                        className="form-control"
                        value={profileData?.bankDetails?.account_holder || ""}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Account Number</Label>

                      <Input
                        innerRef={accountNoRef}
                        disabled
                        name="account_no"
                        type="text"
                        className="form-control"
                        value={profileData?.bankDetails?.account_no || ""}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Bank Name</Label>
                      <Input
                        disabled
                        innerRef={bankNameRef}
                        name="bank_name"
                        type="text"
                        className="form-control"
                        value={profileData?.bankDetails?.bank_name || ""}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">IFSC</Label>
                      <Input
                        disabled
                        name="ifsc"
                        type="text"
                        className="form-control"
                        value={profileData?.bankDetails?.ifsc || ""}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">Account Type</Label>
                      <Input
                        disabled
                        name="account_type"
                        type="text"
                        className="form-control"
                        value={profileData?.bankDetails?.account_type || ""}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}

        <Row>
          <Col xl={12}>
            {(profileData?.aadhaarDetails ||
              profileData?.additionalDetails?.gst_certificate ||
              profileData?.bankDetails) && (
              <CardTitle className="mt-4 mb-4">Documents</CardTitle>
            )}
            {profileData?.aadhaarDetails && (
              <>
                <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                  KYC Documents
                </CardTitle>
                <div className="documents-section">
                  {profileData?.aadhaarDetails?.aadhaar_file && (
                    <div className="documents-box">
                      <div className="file-type">
                        {checkExtension(
                          profileData?.aadhaarDetails.aadhaar_file
                        ) === "pdf" ? (
                          <img src={pdfIcon} alt="" />
                        ) : (
                          <img src={imageIcon} alt="" />
                        )}

                        <div>
                          <p>Aadhaar</p>
                          <Link
                            to={`${process.env.REACT_APP_FILE_URL}/aadhaar/${profileData?.aadhaarDetails.aadhaar_file}`}
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                        <p></p>
                      </div>
                      {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                    </div>
                  )}
                  {profileData?.selfieDetails?.user_image && (
                    <div className="documents-box">
                      <div className="file-type">
                        {checkExtension(
                          profileData?.selfieDetails.user_image
                        ) === "pdf" ? (
                          <img src={pdfIcon} alt="" />
                        ) : (
                          <img src={imageIcon} alt="" />
                        )}

                        <div>
                          <p>Selfie</p>
                          <Link
                            to={`${process.env.REACT_APP_FILE_URL}/${
                              userType === "INVESTOR"
                                ? "avatar/investor"
                                : "avatar/wealth"
                            }/${profileData?.selfieDetails.user_image}`}
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                        <p></p>
                      </div>
                      {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                    </div>
                  )}
                  {profileData?.panDetails?.pan_file && (
                    <div className="documents-box">
                      <div className="file-type">
                        {checkExtension(profileData?.panDetails?.pan_file) ===
                        "pdf" ? (
                          <img src={pdfIcon} alt="" />
                        ) : (
                          <img src={imageIcon} alt="" />
                        )}

                        <div>
                          <p>PAN</p>
                          <Link
                            to={`${process.env.REACT_APP_FILE_URL}/pan/${profileData?.panDetails.pan_file}`}
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                        <p></p>
                      </div>
                      {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                    </div>
                  )}
                </div>
              </>
            )}

            {profileData?.additionalDetails?.gst_certificate && (
              <div className="documents-box">
                <div className="file-type">
                  {checkExtension(
                    profileData?.additionalDetails?.gst_certificate
                  ) === "pdf" ? (
                    <img src={pdfIcon} alt="" />
                  ) : (
                    <img src={imageIcon} alt="" />
                  )}

                  <div>
                    <p>GST Certificate</p>
                    <Link
                      to={`${process.env.REACT_APP_FILE_URL}/businessDocs/${profileData?.additionalDetails.gst_certificate}`}
                      target="_blank"
                    >
                      <span className="text-small text-success cursor-pointer">
                        View
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            )}

            {profileData?.bankDetails && (
              <>
                <CardTitle className="mt-4 mb-4" style={{ fontSize: "14px" }}>
                  Banking Documents
                </CardTitle>
                <div className="documents-section">
                  {profileData?.bankDetails?.cheque_file && (
                    <div className="documents-box">
                      <div className="file-type">
                        {checkExtension(
                          profileData?.bankDetails.cheque_file
                        ) === "pdf" ? (
                          <img src={pdfIcon} alt="" />
                        ) : (
                          <img src={imageIcon} alt="" />
                        )}

                        <div>
                          <p>Cheque</p>
                          <Link
                            to={`${process.env.REACT_APP_FILE_URL}/cheques/${profileData?.bankDetails.cheque_file}`}
                            target="_blank"
                          >
                            <span className="text-small text-success cursor-pointer">
                              View
                            </span>
                          </Link>
                        </div>
                        <p></p>
                      </div>
                      {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                    </div>
                  )}
                </div>
              </>
            )}
            <div className="buttons">
              <Button
                type="button"
                className="btn btn-primary w-md"
                disabled={isLoading}
                onClick={() => submitForVerification()}
              >
                {isLoading ? <Spinners /> : "Submit for Verification"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default KycFinalStep
